import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'

export interface Option {
  value: string
  label: string
}

interface SelectStaticAutocompleteProps {
  options: Option[]
  value?: string | string[]
  onChange: (value: string | string[]) => void
  placeholder?: string
  isClearable?: boolean
  disabled?: boolean
  isMultiple?: boolean
}

const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    borderRadius: 8,
    borderColor: state.isFocused ? '#005EB8' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(0,94,184,0.1)' : 'none',
    minHeight: 44,
    fontSize: '0.9375rem',
    backgroundColor: 'white',
    color: '#3A3A3A',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#F0F8FF' : 'white',
    color: '#3A3A3A',
    fontSize: '0.9375rem',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#3A3A3A',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#A0AEC0',
  }),
}

const Wrapper = styled.div`
  width: 100%;
`

export default function SelectStaticAutocomplete({
  options,
  value,
  onChange,
  placeholder,
  isClearable = true,
  disabled = false,
  isMultiple = false,
}: SelectStaticAutocompleteProps) {
  let selected: any = null

  if (isMultiple) {
    const selectedValues = Array.isArray(value) ? value : []
    selected = options.filter(option => selectedValues.includes(option.value))
  } else {
    const selectedValue = typeof value === 'string' ? value : ''
    selected = options.find(option => option.value === selectedValue) || null
  }

  const handleChange = (nextSelected: any) => {
    if (isMultiple) {
      const values = Array.isArray(nextSelected)
        ? nextSelected.map(option => option.value)
        : []
      onChange(values)
      return
    }

    onChange(nextSelected ? nextSelected.value : '')
  }

  return (
    <Wrapper>
      <Select
        options={options}
        value={selected}
        onChange={handleChange}
        placeholder={placeholder}
        isClearable={isClearable}
        isDisabled={disabled}
        isMulti={isMultiple}
        styles={customStyles}
        menuPortalTarget={document.body}
      />
    </Wrapper>
  )
}
